import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { Trans } from 'react-i18next'
import { Menu } from 'semantic-ui-react'

import _ from 'lodash'

class LeftMenu extends Component {

  render () {
    const { aufschaltung, userInfo } = this.props
    const allowedTo = (what) => userInfo && userInfo.scopes && _.includes(userInfo.scopes, what)

    return (
      <Menu className='App-side-menu-left' vertical={true}>

        { allowedTo('view:dashboard') ? (
          <Menu.Item as={NavLink} exact to='/home'><Trans>Überblick</Trans></Menu.Item>) : null }

        { allowedTo('view:aufschaltung-profiles') && aufschaltung && aufschaltung.profiles && aufschaltung.profiles.length > 0 ? (
          // as={NavLink} exact to='/profiles'
          <Menu.Item ><Trans>Profile</Trans>
            <Menu.Menu vertical='true' style={{marginLeft: '0.2em'}}>
              { aufschaltung.profiles.map((p, i) => (
                <Menu.Item as={NavLink} exact key={i} to={`/profile/${p.nickname}`}>
                  {p.nickname}
                </Menu.Item>
              ))}
            </Menu.Menu>
          </Menu.Item>
        ) : null }

        { allowedTo('view:aufschaltung-apis') && aufschaltung && aufschaltung.apis && aufschaltung.apis.length > 0 ? (
          // as={NavLink} exact to='/apis'
          <Menu.Item  ><Trans>APIs</Trans>
            <Menu.Menu vertical='true' style={{marginLeft: '0.2em'}} >
              { aufschaltung.apis.map((a, i) => {
                return (
                  !a.for_internal_apikp_use_only ? (
                    <Menu.Item as={NavLink} exact key={i} to={`/api/${a.nickname}`}>
                      {a.nickname}
                    </Menu.Item>
                  ) : null
                )
              })}
            </Menu.Menu>
          </Menu.Item>
        ) : null }

        { allowedTo('view:aufschaltung-apps') && aufschaltung && aufschaltung.apps && aufschaltung.apps.length > 0 ? (
          // as={NavLink} exact to='/apps'
          <Menu.Item ><Trans>Apps &amp; Tools</Trans>
            <Menu.Menu vertical='true' style={{marginLeft: '0.2em'}}>
              { aufschaltung.apps.map((a, i) => (
                <Menu.Item className='item active' as={NavLink} exact key={i} to={`/app/${a.nickname}`}>
                  {a.nickname}
                </Menu.Item>
            ))}
            </Menu.Menu>
          </Menu.Item>
        ) : null }

        { allowedTo('view:documentation') ? (
          // as={NavLink} exact to='/doc'
          <Menu.Item><Trans>Dokumentation</Trans>
            <Menu.Menu vertical='true' style={{marginLeft: '0.2em'}}>
              <Menu.Item as={NavLink} exact to='/doc/news'>
                <Trans>Aktuelles</Trans>
              </Menu.Item>
              <Menu.Item as={NavLink} exact to='/doc/overview'>
                <Trans>Überblick</Trans>
              </Menu.Item>
              <Menu.Item as={NavLink} exact to='/doc/format'>
                Format
              </Menu.Item>
              <Menu.Item as={NavLink} exact to='/doc/apis'>
                APIs
              </Menu.Item>
              <Menu.Item as={NavLink} exact to='/doc/faq'>
                FAQ
              </Menu.Item>
              <Menu.Item as={NavLink} exact to='/doc/best-practices'>
                Best Practices
              </Menu.Item>
            </Menu.Menu>
          </Menu.Item>
        ) : null }

      </Menu>
    )
  }
}

export default LeftMenu



// WEBPACK FOOTER //
// ./src/components/LeftMenu.js